import { memo } from 'react';
import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import * as icons from '@assets/icons';

export type IconType = keyof typeof icons;
export const iconTypes: IconType[] = Object.keys(icons) as any[];

interface IconProps {
  /**
   * 사용 할 아이콘 타입
   */
  icon: IconType;
  /**
   * 아이콘 색상
   */
  color?: string;
  /**
   *  아이콘 크기
   */
  size?: string | number;
  /**
   * 채워진 아이콘인지 아닌 아이콘인지를 설정합니다. 색상이 설정된 아이콘을 가져다 쓰는 것을 권장합니다.
   */
  isFilled?: boolean;

  /**
   * path 대신 rect를 이용한 svg인 경우에 이용합니다.
   */
  isRect?: boolean;

  /**
   * 커스텀을 위한 클래스 명
   */
  className?: string;

  /**
   * isFilled, isRect 등의 속성이 두개 이상 필요할 때, 호출하고 있는 부모에서, css 넘겨줍니다.
   */
  customCss?: SerializedStyles;
}

const customColor = (isFilled: boolean, color: string | undefined, isRect: boolean) => {
  if (!color) {
    return;
  }

  if (isFilled) {
    return css`
      * {
        stroke: ${color};
      }
    `;
  }

  if (isRect) {
    return css`
      rect {
        fill: ${color};
      }
    `;
  }

  return css`
    path {
      fill: ${color};
    }
  `;
};

const Icon = ({ icon, color, size, isFilled = false, isRect = false, className, customCss }: IconProps) => {
  const SVGIcon = icons[icon];

  const css = size
    ? [{ width: size, height: size }, customColor(isFilled, color, isRect)]
    : [customColor(isFilled, color, isRect)];

  if (customCss) {
    css.push(customCss);
  }

  return (
    <>
      <SVGIcon css={css} className={className} style={{ flexShrink: '0' }} />
    </>
  );
};

export default memo(Icon);
